/* global axios */
import ApiClient from './ApiClient';

class KanbanPipelinesAPI extends ApiClient {
  constructor() {
    super('kanban/pipelines', { accountScoped: true });
  }

  // GET /kanban/pipelines -> auto-seeds "Padrão" server-side on first call.
  // Each pipeline already embeds its columns.
  getPipelines() {
    return axios.get(this.url);
  }

  createPipeline(data) {
    return axios.post(this.url, { pipeline: data });
  }

  updatePipeline(id, data) {
    return axios.patch(`${this.url}/${id}`, { pipeline: data });
  }

  deletePipeline(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  columnsUrl(pipelineId) {
    return `${this.url}/${pipelineId}/columns`;
  }

  createColumn(pipelineId, data) {
    return axios.post(this.columnsUrl(pipelineId), { column: data });
  }

  updateColumn(pipelineId, columnId, data) {
    return axios.patch(`${this.columnsUrl(pipelineId)}/${columnId}`, {
      column: data,
    });
  }

  deleteColumn(pipelineId, columnId) {
    return axios.delete(`${this.columnsUrl(pipelineId)}/${columnId}`);
  }

  reorderColumns(pipelineId, orderedIds) {
    return axios.post(`${this.columnsUrl(pipelineId)}/reorder`, {
      ordered_ids: orderedIds,
    });
  }
}

export default new KanbanPipelinesAPI();
